import {useNavigate} from "react-router-dom";

import {Button} from "primereact/button";
import {Column} from "primereact/column";

import ListView from "../../component/ListView";
import {TipoUsuarioKeycloak} from "../../keycloak/TipoUsuarioKeycloak";
import SemPermissao from "../erro/SemPermissao";
import {RoleBasedAccess} from "../../keycloak/RoleBasedAccess";
import Pergunta from "../../model/Pergunta";

function PerguntaList() {
    const navigate = useNavigate();

    const situacaoTemplate = (entidade: Pergunta) => {
        return entidade.ativo ? "Ativa" : "Inativa";
    }

    const botoesPrincipaisExtra = [(
        <Button key={"respostasKey"} icon={"pi pi-chart-pie"} className="mr-2"
                label={"Respostas"} raised size={"large"} severity={"success"}
                title={"Gráficos das perguntas respondidas"}
                onClick={() => navigate("/pergunta/respostas")}/>
    )];

    return (
        <>
            <RoleBasedAccess roles={TipoUsuarioKeycloak.ADMIN}
                             forbiddenFallback={<SemPermissao />}>
                <ListView title={"Questionário"}
                          botoesPrincipaisAdicionais={botoesPrincipaisExtra}
                          id={`${process.env.REACT_APP_REST_PERGUNTA}`}>
                    <Column field="descricao" header="Pergunta" sortable />
                    <Column field="ativo" header="Situação" body={situacaoTemplate} sortable />
                </ListView>
            </RoleBasedAccess>
        </>
    );
}

export default PerguntaList;
